import moment from 'moment';

export class RouteAssignment {
    id: number;
    created: Date;
    deleted: Date;
    completed: Date;
    onAssignmentFrom: Date;
    declined: Date;
    configId: number;
    routeId: number;
    routeName: string;
    routeLength: number;
    vehicleId: number;
    shiftId: number;
    queueOrder: number;
    distanceDriven: number; // meters
    distanceDrivenOffRoute: number;
    distanceDrivenOnRoute: number;
    timeDriven: number; // seconds
    timeDrivenOffRoute: number;
    timeDrivenOnRoute: number;
    percentCompleted: number;
    cancelled?: boolean;
    vehicleName?: string;
    driverName?: string;
    groupUuid?: string;

    /*
    /*
     * First list out completed/declined items
     * and then all others by queue order
     */
    static sortByStatus(assignments: RouteAssignment[]): RouteAssignment[] {
        return assignments.sort((a, b) => {
            if ((a.completed || a.declined) && (b.completed || b.declined)) {
                return moment(a.completed ?? a.declined).isBefore(moment(b.completed ?? b.declined)) ? -1 : 1;
            } else {
                if (a.completed || a.declined) {
                    return -1;
                }
                if (b.completed || b.declined) {
                    return 1;
                }
                return a.queueOrder < b.queueOrder ? -1 : 1;
            }
        });
    }

    static sortByCreated(assignments: RouteAssignment[]): RouteAssignment[] {
        return assignments.sort((a, b) => {
            return moment(a.created).isBefore(moment(b.created)) ? -1 : 1;
        });
    }
}

export class VehicleRouteAssignmentStatus {
    vehicleId: number;
    status: RouteAssignmentStatus;
    routeAssignments: RouteAssignment[];
}

export enum RouteAssignmentStatus {
    NO_ASSIGNMENT = 'NO_ASSIGNMENT',
    REQUESTED = 'REQUESTED',
    PENDING = 'PENDING',
    ON_ASSIGNMENT = 'ON_ASSIGNMENT',
}

export enum RouteAssignmentQueue {
    IMMEDIATE = 'IMMEDIATE',
    NEXT = 'NEXT',
    END = 'END',
}

export class RouteTrackingStatus {
  route_id: number;
  set_id: number;
  sessionkey: number;
  locationsourceid: number;
  tracking_started: number;
  updated: number;
  percent_complete: number;
  distance_off_route_meters: number;
  distance_on_route_meters: number;
  time_off_route_seconds: number;
  time_on_route_seconds: number;
}
